import { useEffect } from "react";

/**
 * SEO meta yönetimi (React-side, runtime).
 *
 * 3 site mimarisi:
 *  - gercekolay.com (HAM, kullanıcı yüzü)         → canonical=kendisi, amphtml=speedshort.live (sadece listing'de)
 *  - speedshort.live (AMP proxy)                  → canonical=gercekolay.com (mask'tan inherit)
 *  - gercekmask.site (mask AMP, BTK yedek)        → canonical=gercekolay.com
 *
 * ROOT (/) ve /ilan/* sayfalarında amphtml link YOK.
 */

const HAM_DOMAIN = "https://gercekolay.com";
const AMP_DOMAIN = "https://speedshort.live";

function setOrCreateLink(rel, href) {
  let link = document.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", rel);
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

function removeLink(rel) {
  const link = document.querySelector(`link[rel="${rel}"]`);
  if (link) link.remove();
}

function setOrCreateMeta(name, content, attr = "name") {
  let meta = document.querySelector(`meta[${attr}="${name}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute(attr, name);
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", content);
}

// AMP varlığı: sadece listing sayfaları (city ve district)
function hasAmpVersion(path) {
  if (!path) return false;
  const p = path.startsWith("/") ? path : `/${path}`;
  // /{city}/escort  veya  /{city}/{district}/escort
  return /^\/[a-z0-9-]+(?:\/[a-z0-9-]+)?\/escort\/?$/.test(p);
}

export function useSeo({ path, title, description, ogTitle, ogImage }) {
  useEffect(() => {
    const cleanPath = (path || "/").startsWith("/") ? path : `/${path}`;
    const canonicalUrl = `${HAM_DOMAIN}${cleanPath === "/" ? "" : cleanPath}`;

    if (title) document.title = title;
    if (description) setOrCreateMeta("description", description);

    setOrCreateLink("canonical", canonicalUrl);

    // amphtml: sadece listing sayfalarında, diğer route'larda kaldir
    if (hasAmpVersion(cleanPath)) {
      const ampUrl = `${AMP_DOMAIN}${cleanPath}`;
      setOrCreateLink("amphtml", ampUrl);
    } else {
      removeLink("amphtml");
    }

    // OpenGraph
    setOrCreateMeta("og:title", ogTitle || title || "Nova & Platinium", "property");
    setOrCreateMeta("og:url", canonicalUrl, "property");
    setOrCreateMeta("og:type", "website", "property");
    if (description) setOrCreateMeta("og:description", description, "property");
    if (ogImage) setOrCreateMeta("og:image", ogImage, "property");

    // Twitter
    setOrCreateMeta("twitter:card", "summary_large_image");
    setOrCreateMeta("twitter:title", ogTitle || title || "Nova & Platinium");
    if (description) setOrCreateMeta("twitter:description", description);
  }, [path, title, description, ogTitle, ogImage]);
}
